/**
 *  default prefix "CARD_NUMBERS_"
 */

export const AT_CARD_NUMBER_ACTION_SET = 'CARD_NUMBERS_CARD_NUMBER_ACTION_SET';
